// clip-untrusted-text.ts
//
// Text that came from outside the controller (a GitLab server's pipeline URL or
// status, an error message of a credential helper) reaches the operator's
// terminal, `status --json` and the journal inside release-flow reasons. Same
// convention as commit-owner-skipped-pathspecs-line.ts (review 261001 L6, round 2
// L5): every control character — ANSI escapes, newlines, NUL — becomes "?", and
// the text is cut at a cap with "…". The host is the org's own GitLab, so this is
// hygiene against a forged line or escape sequence, not a trust boundary.

export function replaceControlChars(text: string): string {
  return [...text]
    .map((ch) => {
      const code = ch.charCodeAt(0);
      return code < 0x20 || (code >= 0x7f && code <= 0x9f) ? "?" : ch;
    })
    .join("");
}

export function clipUntrustedText(text: string, maxChars: number): string {
  const clean = replaceControlChars(text);
  return clean.length > maxChars ? `${clean.slice(0, maxChars)}…` : clean;
}
